// The payload is the deleted contact's id, wrapped in an object: synapse's `DefaultPayload` requires
// `payload` to be a record (or an array of records), never a bare primitive.
export type BeneficiaryContactDeletedPayload = {
	contactId: number;
};

export type BeneficiaryContactDeletedAction = {
	type: 'BENEFICIARY_CONTACT_DELETED';
	payload: BeneficiaryContactDeletedPayload;
	beneficiaryId: number;
};

export default (
	payload: BeneficiaryContactDeletedPayload,
	beneficiaryId: number,
): BeneficiaryContactDeletedAction => ({
	type: 'BENEFICIARY_CONTACT_DELETED',
	payload,
	beneficiaryId,
});
